import styled from 'styled-components';

export const Wrapper = styled.div`
  position: absolute;
  top: 12px;
  left: 12px;
  line-height: 1;
  z-index: 3;
  -webkit-font-smoothing: antialiased;
`;
